import { mapState } from 'vuex';

export default {

    render() {
        return null;
    },

    computed: mapState({
        user: state => state.user,
    }),

    mounted() {
        if (this.user) {
            this.$router.push('/ceremonies');

            return;
        }

        if (window.IS_LITE_VERSION) {
            this.$router.push('/login');
        } else {
            this.$router.push('/code');
        }
    },
};
